import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { data } from 'jquery';
import { Observable } from 'rxjs';
import { endWith, map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class DashboarduiService {

  constructor(private http: HttpClient) { }

  //private newEndPoint: string = "https://idsdatahubdashboardapi.azurewebsites.net/api";
  //private newEndPoint: string="https://idsdatahubdashboardapinew.azurewebsites.net/api"
   private newEndPoint: string = "https://fxdhdashboardapi.idsnext.live/api";
  testCROSError() {
    let data = { 'pmscode': 1838, 'cmcode': "CM9902", 'type': "ReceivedXML", 'token': 'ca3f897d-3db5-4381-94ea-6bfd84f74c17' };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    //let endPoint = "https://ids-dh-ari.azurewebsites.net/rep_test";
    let endPoint = "https://idsdhariapi.idsnext.com/rep_test";
    // let endPoint = "https://idsnextdatahubapiconfig-b.idsnext.com/NewHeartBeat/8215";//
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }


  // Common API's List 
  getfootfall(UID: any, MENU: any, OPTION: any) {
    let data = { 'UID': UID, 'SELECTEDPROPERTY': MENU, 'typ': OPTION };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Strlog/Footfall";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }
  getCMLIST(PMSCUSTCODE: any) {
    let data = { 'pmscode': PMSCUSTCODE };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    let endPoint = this.newEndPoint + "/AllCmLog/IsAllCmLog";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }
  getIDSUsersProperties(UserId: any) {
    let data = { 'UserId': UserId }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/DHUICM/GetCMHOTELS";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  /* Rate & Restriction API's Details  */
  getRateToChannel() {
    // let data = { 'UserId': UserId }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/DHUICM/GetRateProducts";
    return this.http
      .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  GetRateReportChannel(SOURCE: any, PMSCUSTCODE: any, CMCode: any, selectedDate: any, selectedTOODate: any, echoToken: any, PGF: any, PGT: any, searchText:any) {
    let data = { 'source': SOURCE, 'pmscode': PMSCUSTCODE, 'cmcode': CMCode, 'fromdate': selectedDate, 'todate': selectedTOODate, "ECHOTOKEN": echoToken, 'PaginationFromId': PGF, 'PaginationToId': PGT,'Search':searchText };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/RateSync/GetChannelAndFortune"; // To insert API URL here
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  getRateToChannelXML(PMSCUSTCODE: any, selectedChannel: any, Type: any, TOKEN: any, Source: any) {
    let data = { 'pmscode': PMSCUSTCODE, 'cmcode': selectedChannel, 'type': Type, 'token': TOKEN, 'Source': Source };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/AriXml/NewRateXml";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  getrestrictionXML(PMSCUSTCODE: any, selectedChannel: any, Type: any, TOKEN: any) {
    let data = { 'pmscode': PMSCUSTCODE, 'cmcode': selectedChannel, 'type': Type, 'token': TOKEN };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/DHCustomer/GetRestrictionXML";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }


  getRestrictionLogs(PMSCUSTCODE: any, CMCODE: any, selectedDate: any, selectedTOODate: any, SearchAllParams: any, PGF: any, PGT: any) {
    let data = { 'pmscode': PMSCUSTCODE, 'cmcode': CMCODE, 'fromdate': selectedDate, 'todate': selectedTOODate, 'search': SearchAllParams, 'PaginationFromId': PGF, 'PaginationToId': PGT };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/DHCustomer/GetRestrictionReport";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }
  /* Inventory Delivery to Channel for FX & FN  */
    getchannelFXFN() {
    // let data = { 'UserId': UserId }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/DHUICM/GetINVProducts";
    return this.http
     .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }  
 //Indhuja 21-08-2025 Start
     getchannelFXFNStaah() {
    // let data = { 'UserId': UserId }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/DHUICM/GetpropertiesStaahInvLog";
    return this.http
    .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }
  //Indhuja 21-08-2025 End
  /* Login API */
  isLogin(Userid: any, pwd: any) {
    let data = { 'UserId': Userid, 'Password': pwd };
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    // let endPoint = this.newEndPoint + "/Login/IsLogin";
    let endPoint = this.newEndPoint + "/Login/LoginValidate";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
  /* Dashboard API */
  readHeartbeat(pmsCustCode: any) {
    let data = { 'pmscode': pmsCustCode }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Login/getheartbeat";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
    //Indhuja 27-11-2025 Start
   readPhaseIIHeartbeat(pmsCustCode: any) {
    let data = { 'pmscode': pmsCustCode }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Login/phaseIIHeartbeat";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
  //Indhuja 27-11-2025 End
  readWindowsServiceVersion(pmsCustCode: any) {
    let data = { 'pmscode': pmsCustCode }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Login/GetWinService";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
  readHotelSearch(pmsCustCode: any) {
    let data = { 'Pmscode': pmsCustCode }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Login/GetHotelSearch";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  statisticsData() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Login/GetConnectionStatus";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* Offline Hotels API */
  hotelDataWithMultiEXE(countryName: any) {
    let data = { "Country": countryName }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/General/GettwoEXE";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }


  getTwoEXECountryList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/General/TwoEXECountryList";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  getCountryList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/General/Getcountrylist";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
  offlineHotelData(countryName: any) {
    let data = { "Country": countryName }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/General/GetOfflineHotels";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* Heartbeat Logs */
  getHeartbeatLogPropList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/General/GetFNProperties";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  getHeartbeatLogList(pmscode:any) {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/General/ReadHeartBeatLogHistory/" + pmscode
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* Hotels with multiple CM/CRS */
  hotelDataWithMultCMCRS() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/General/GetHotleswithTwoCM";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* Active Count for dashboard */
  dashboardActivateCM(pmsCustCode: any) {
    let data = { 'pmscode': pmsCustCode }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Login/GetProductandCM";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
  /* FXCRS Properties*/
  getFXCRSProperty() {
    // let data = { 'pmscode': pmsCustCode}
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/DHUICM/ISGetProductFXCRS";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  getRateTOPMS() {
    // let data = { 'pmscode': pmsCustCode}
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/DHUICM/GetRateToPMS";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* Inventory API's */
  getRoom(PMSCUSTCODE: any) {
    let data = { 'pmscode': PMSCUSTCODE };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FxcrsInv/IsFxcrsInvRoom";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  getROOMLIST(PMSCUSTCODE: any) {
    let data = { 'pmscode': PMSCUSTCODE };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/AllCmLog/GetRoomType";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  getAriXML(PMSCUSTCODE: any, TOKEN: any, TYP: any) {
    let data = { 'pmscode': PMSCUSTCODE, 'token': TOKEN, 'xchangeformat': TYP };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FxcrsInv/IsFxcrsInvXML";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  getinventory(PMSCUSTCODE: any, selectedDate: any, Roomtype: any, Source: any, PGF: any, PGT: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'Date': selectedDate, 'RoomTypeBy': Roomtype, 'SourceBy': Source, 'PaginationFromId': PGF, 'PaginationToId': PGT };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FxcrsInv/IsFxcrsInv";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  /* Inventory Delivery To Channels For FN&FX */

  getinventorylog(PMSCUSTCODE: any, selectedChannel: any, selectedDate: any, Roomtype: any, Source: any, PGF: any, PGT: any) {
    let data = { 'PMSCODE': PMSCUSTCODE, 'CMCODE': selectedChannel, 'DATE': selectedDate, 'ROOMTYP': Roomtype, 'SOURCE': Source, 'PaginationFromId': PGF, 'PaginationToId': PGT };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Inventorylog/IsInventorylog";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }
  getinventoryXML(PMSCUSTCODE: any, selectedChannel: any, Type: any, TOKEN: any, sourceTable: any) {
    let data = { 'pmscode': PMSCUSTCODE, 'cmcode': selectedChannel, 'SOURCE': Type, 'token': TOKEN, 'sourceTable': sourceTable };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/AriXml/IsAriXml";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  /* Booking Download and Upload */
  getBookingDownloadlog() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Bookinglog/IsBookingDW";
    return this.http.get(endPoint, { headers: headers })
      .pipe(map(res=>JSON.parse(JSON.stringify(res))));
  }

  getBookingLogDownloadRead(PMSCUSTCODE: any, fromDate: any, ToDate: any, PGF: any, PGT: any,ValSearchDownload:any) {
    let data = { 'PMSCODE': PMSCUSTCODE, 'FRMDAT': fromDate, 'TOODAT': ToDate, 'PaginationFromId': PGF, 'PaginationToId': PGT,'Search':ValSearchDownload };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Bookinglog/IsBookingDWRead";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  getBookingLogUploadRead(PMSCUSTCODE: any, fromDate: any, ToDate: any, PGF: any, PGT: any, ValSearchUpload:any,UserID:any) {
    let data = { 'PMSCODE': PMSCUSTCODE, 'FRMDAT': fromDate, 'TOODAT': ToDate, 'PaginationFromId': PGF, 'PaginationToId': PGT,'Search':ValSearchUpload,'UserID':UserID };//indhuja 20-12-2025 add the userid parameter
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Bookinglog/IsBookingUPRead";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  getBookingLogUploadXML(PMSCUSTCODE: any, fromDate: any, MsgTyp: any,UserID:any) {
    let data = { 'Pmscode': PMSCUSTCODE, 'Token': fromDate, 'MsgTyp': MsgTyp,'UserID':UserID };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Bookinglog/IsBookingDWxml";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

/* Booking Download and Upload - NewPipe*/
getBookingLogDownloadNewPipeRead(PMSCUSTCODE: any, fromDate: any, ToDate: any, PGF: any, PGT: any,ValSearchDownload:any) {
  let data = { 'PMSCODE': PMSCUSTCODE, 'FRMDAT': fromDate, 'TOODAT': ToDate, 'PaginationFromId': PGF, 'PaginationToId': PGT,
    'Search':ValSearchDownload };//add the userid paramter Indhuja 29122025
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/Bookinglog/ReadBookingsDWNewPipe";
  return this.http.post(endPoint, data, { headers: headers })
    .pipe(map(res=>JSON.parse(JSON.stringify(res))));
}

getBookingLogDownloadNewPipeXML(PMSCUSTCODE: any, fromDate: any, MsgTyp: any,UserID:any) {
  let data = { 'Pmscode': PMSCUSTCODE, 'Token': fromDate, 'MsgTyp': MsgTyp,'UserID':UserID };//Indhuja 29-12-2025 add userid
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/Bookinglog/GetXMLBookingsDWNewPipe";
  return this.http.post(endPoint, data, { headers: headers })
    .pipe(map(res=>JSON.parse(JSON.stringify(res))));
}

getBookingLogUploadNewPipeRead(PMSCUSTCODE: any, fromDate: any, ToDate: any, PGF: any,
   PGT: any, ValSearchUpload:any,UserID:any) {
  let data = { 'PMSCODE': PMSCUSTCODE, 'FRMDAT': fromDate, 'TOODAT': ToDate, 'PaginationFromId': PGF, 
    'PaginationToId': PGT,'Search':ValSearchUpload ,'UserID':UserID };//Indhuja 29-12-2025 add userid};
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/Bookinglog/ReadBookingsUPNewPipe";
  return this.http.post(endPoint, data, { headers: headers })
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}

getBookingLogUploadNewPipeXML(PMSCUSTCODE: any, fromDate: any, MsgTyp: any) {
  let data = { 'Pmscode': PMSCUSTCODE, 'Token': fromDate, 'MsgTyp': MsgTyp };
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/Bookinglog/GetXMLBookingsUPNewPipe";
  return this.http.post(endPoint, data, { headers: headers })
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}

getBookingLogDownloadReprocess(payloadRequest:any) {
  let data = payloadRequest;
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/Bookinglog/ReprocessBookingsDWNewPipe";
  return this.http.post(endPoint, data, { headers: headers })
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
  

  /* Channels Booking */
  getbookinglog(PMSCUSTCODE: any, CMCODE: any, selectedDate: any, selectedTOODate: any, PGF: any, PGT: any, searchParam: any) {
    let data = { 'PmsCode': PMSCUSTCODE, 'CMCode': CMCODE, 'From': selectedDate, 'To': selectedTOODate, 'PaginationFromId': PGF, 'PaginationToId': PGT, "Search": searchParam };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Bookinglog/IsBookinglog";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  getTCTOPMS(PMSCUSTCODE: any, LOGS: any, CMCODE: any, selectedDate: any, selectedTOODate: any, pmsnub: any, PGF: any, PGT: any, Userid: any) {
    pmsnub = "undefined"
    Userid = "undefined"
    let data = { 'pmscode': PMSCUSTCODE, 'cmcode': CMCODE, 'check': LOGS, 'fromdate': selectedDate, 'toodate': selectedTOODate, 'search': pmsnub, 'PaginationFromId': PGF, 'PaginationToId': PGT, 'userid': Userid };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/PMStoCMLog/IsPMStoCMLog";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }


  getbookingXML(PMSCUSTCODE: any, selectedChannel: any, TOKEN: any, xmltype: any) {
    let data = { 'pmscode': PMSCUSTCODE, 'cmcode': selectedChannel, 'token': TOKEN, 'Type': xmltype };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/AriXml/IsAriBookXml";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  getPMSbookingXML(Typ: any, TOKEN: any) {
    let data = { 'xchangeformat': Typ, 'token': TOKEN };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/AriXml/IsPMSAriBookXml";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  /* To Load XML Data from individual */
  loadXMLData(url: any) {
    let data = { 'remoteUrl': url };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FileDownload/Download";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  /* BTEA Screens */
  getBTEAGetProperties() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Btea/GetProperties";
    return this.http
      .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  readBTEAData(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Btea/BteaRead";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* EDW Screens */
  getEDWGetProperties() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/EDW/GetProperties";
    return this.http
      .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }


  getedwlog(PMSCUSTCODE: any, selectedDate1: any, selectedTOODate1: any, UID: any, status: any) {
    let data = {
      'PMSCODE': PMSCUSTCODE, 'FROMDATE': selectedDate1, 'TOODATE': selectedTOODate1,
      'UID': UID, 'STATUS': status
    };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/EDW/ReadEDW";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }
  getprocessedwlog(PMSCUSTCODE: any, selectedDate1: any,seletedtodate:any) {
    let data = { 'PMSCODE': PMSCUSTCODE, 'FROMDATE': selectedDate1,'TOODATE':seletedtodate };//add one parameter TOODATE
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/EDW/ReprocessEDW";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }
  getaccdate(PMSCUSTCODE: any, typ: any, selectedTOODate1: any) {
    let data = { 'SELECTEDPROPERTY': PMSCUSTCODE, 'typ': typ, 'FROMDATE': selectedTOODate1 };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/EdwLog/getaccdate";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  /* STR Screens */
  getSTRProperties() {
    // let data = { 'UserId': UserId }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/STR/STRGetProperties";
    return this.http
    .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  readSTRPropertiesData(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/STR/ReadWriteSTR";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }


  /* Genernal CRM Screens */
  getCRMList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CRM/GetCRMList";
    return this.http
      .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

 /*  readCRMReadAPIData(requestPayload: any) {
    let data = { 'PartnerName': requestPayload }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CRM/ReadGeneralCRM";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  } */
 //Read crm -- Indhuja 18-02-2025 -- add pmscode parameter
  readCRMReadAPIData(requestPayload: any,pmscode:any) {
    let data = { 'PartnerName': requestPayload ,'PMSCODE':pmscode}
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CRM/ReadGeneralCRM";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
  /* Get General PropertyList Indhuja 18-02-2025*/
  getCRMPropertyList(requestPayload: any) {
    let data = { 'PartnerName': requestPayload }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CRM/GetGeneralCRMProperties";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
  /* BWCRM Screens */
  getBWCRMist() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CRM/GetBWCRMList";
    return this.http
     .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

/*   readBWCRMReadAPIData() {
    // let data = { 'partnerCode': requestPayload }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CRM/ReadBWCRM";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  } */
 //Indhuja 19-20-2025 add the pmscode,frmdate,toodate
  readBWCRMReadAPIData(PMSCUSTCODE: any, FROMDATE: any, TooDate: any) {
    let data = { 'PMSCODE': PMSCUSTCODE,'FRMDATE':FROMDATE,'TOODATE':TooDate }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CRM/ReadBWCRM";
    return this.http
      .post(endPoint,data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
  /* OTAInsights Screens */
  getOTAInsightsList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/OTAInsight/GetOTAList";
    return this.http
    .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

/*   readOTAInsightsReadAPIData(PMSCUSTCODE: any, FROMDATE: any, TooDate: any, Status: any) {
    let data = { 'PMSCODE': PMSCUSTCODE, 'FROMDATE': FROMDATE, 'TODATE': TooDate, 'STATUS': Status };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/OTAInsight/ReadOTA";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  } */
   //OTAinsight log new 27-01-2025
   readOTAInsightsReadAPIData(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any)
   {
   let data={'PMSCODE':PMSCUSTCODE,'FRMDATE':selectedDate,'TOODATE':selectedTOODate};
   let header=new HttpHeaders({'Content-Type':'application/json'});
   let endPoint=this.newEndPoint+"/OTAInsight/ReadOTA";
   return this.http.post(endPoint,data,{headers:header})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
   }

  /* FXServiceLog Screens */
  readFXServiceLogReadAPI() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXService/ReadFXService";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* Pulze 24/7 Log */
  getPulzeCountryList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Pulze/ReadPulzeCountryList";
     //let endPoint = this.newEndPoint + "/Pulze/ReadPulze";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
  readPulzeAPI(countryName: any) {
    let data = { "Country": countryName }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Pulze/ReadPulze";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* Revnomix Log */
  getRevnomixList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/Revnomix/ReadRevnomix";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* FXInvoice Log */
  getFXInvoiceProp() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXEinvoice/GetProperties";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  readreadFXInvoiceAPI(PMSCUSTCODE: any, FROMDATE: any, TooDate: any, Status: any, billTokensearch:any) {
    let data = { 'pmscode': PMSCUSTCODE, 'frmdate': FROMDATE, 'toodate': TooDate, 'status': Status, 'Search':billTokensearch};
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXEinvoice/ReadEinvoice";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  FXInvoiceJSON(PMSCUSTCODE: any, token: any, type: any) {
    let data = { 'pmscode': PMSCUSTCODE, 'token': token, 'type': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXEinvoice/GetEinvoicejson";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* BBR Log */
  getBBRPropList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/BBR/GetProperties";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  readBBRAPI(PMSCUSTCODE: any, FROMDATE: any, TooDate: any, Status: any) {
    let data = { 'PMSCODE': PMSCUSTCODE, 'FRMDATE': FROMDATE, 'TOODATE': TooDate, 'STATUS': Status };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/BBR/ReadBBRLog";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  BBRJSON(PMSCUSTCODE: any, token: any, type: any) {
    let data = { 'PMSCODE': PMSCUSTCODE, 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/BBR/GetBBRLogjson";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* BYT Log */
  getBYTPropList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/BYT/GetBYTProperties";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  readBYTAPI(PMSCUSTCODE: any, FROMDATE: any, TooDate: any, Status: any) {
    let data = { 'PMSCODE': PMSCUSTCODE, 'FRMDATE': FROMDATE, 'TOODATE': TooDate, 'STATUS': Status };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/BYT/ReadBYTLog";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  BYTJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/BYT/ReadBYTLogJson";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }


  /* FXGEM Log */
  getFXGEMPropList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXGEM/GetUploadProperties";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  readFXGEMAPI(PMSCUSTCODE: any, FROMDATE: any, TooDate: any, Status: any) {
    let data = { 'PMSCODE': PMSCUSTCODE, 'FRMDATE': FROMDATE, 'TOODATE': TooDate, 'STATUS': Status };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXGEM/ReadUploadLog";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  FXGEMJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXGEM/ReadUploadLogJSON";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  // Email Log
  readFXGEMEmailLogAPI(PMSCUSTCODE: any, FROMDATE: any, TooDate: any, Status: any) {
    let data = { 'PMSCODE': PMSCUSTCODE, 'FRMDATE': FROMDATE, 'TOODATE': TooDate, 'STATUS': Status };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXGEM/ReadEmailLog";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  FXGEMEmailLogJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXGEM/ReadEmailLogJSON";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }


  /* FXGEM POS APP Log */
  getPOSAppLogPropList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXGEM/GetgemposappProperties";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  readPOSAppLogAPI(PMSCUSTCODE: any, FROMDATE: any, TooDate: any, Status: any) {
    let data = { 'PMSCODE': PMSCUSTCODE, 'FRMDATE': FROMDATE, 'TOODATE': TooDate, 'STATUS': Status };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXGEM/ReadgemposappLog";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  POSAppLogJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXGEM/ReadgemposappJSON";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }


  /* FXGEM POS Log */

  readPOSLogAPI(PMSCUSTCODE: any, FROMDATE: any, TooDate: any, Status: any) {
    let data = { 'PMSCODE': PMSCUSTCODE, 'FRMDATE': FROMDATE, 'TOODATE': TooDate, 'STATUS': Status };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXGEM/ReadGemPos";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  POSLogJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXGEM/ReadGemPosJson";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* Hotels By Channel Managers */
  getChannelsList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/General/GetChannellist";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
  HotelDataByChannels(channelcode: any) {
    let data = { "channelcode": channelcode }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/General/ReadHotelsbyCM";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }


  /* FXGEM Document Log */
  readDocLogAPI(PMSCUSTCODE: any, FROMDATE: any, TooDate: any, Status: any) {
    let data = { 'PMSCODE': PMSCUSTCODE, 'FRMDATE': FROMDATE, 'TOODATE': TooDate, 'STATUS': Status };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXGEM/ReadDocumentLog";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  FXGEMDocLogJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXGEM/ReadDocumentLogJson";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }


  /* FXGEM Settlement Log */

  readSettlementLogAPI(PMSCUSTCODE: any, FROMDATE: any, TooDate: any, Status: any) {
    let data = { 'PMSCODE': PMSCUSTCODE, 'FRMDATE': FROMDATE, 'TOODATE': TooDate, 'STATUS': Status };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXGEM/ReadSettlementLog";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  FXGEMSettlementLogJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/FXGEM/ReadSettlementLogJson";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* Guest Profile Log */
  getGuestProfiePropList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/GuestProfile/GetProperties";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  // Guest Profile FN Logs
  readGuestProfieLogAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/GuestProfile/ReadGuestProfileLog";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  GuestProfieLogJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/GuestProfile/ReadGuestProfileLogJSON";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }


  readGuestProfieChannelLogAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/GuestProfile/ReadChannelLog";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  GuestProfieChannelLogJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/GuestProfile/ReadChannelLogJSON";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* Guest Profile Upload Log */
  GuestProfieUploadPropList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/DHUICM/GetRateToPMS";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  readGuestProfieUpload(PMSCUSTCODE: any, FROMDATE: any, TooDate: any, Status: any) {
    let data = { 'PMSCODE': PMSCUSTCODE, 'FRMDATE': FROMDATE, 'TOODATE': TooDate, 'STATUS': Status };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/GuestProfile/ReadProfileFNFXCRSup";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  GuestProfieUploadJSON(token: any) {
    let data = { 'TOKEN': token };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/GuestProfile/GetProfileFNFXCRSupXML";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  // Company Profile FN Logs

  getCompanyProfiePropList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CompanyProfile/GetProperties";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
  readCompanyProfieLogAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CompanyProfile/ReadFNLog";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  CompanyProfieLogJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CompanyProfile/ReadFNLogJSON";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }


  readCompanyProfieChannelLogAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CompanyProfile/ReadChannelLog";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  CompanyProfieChannelLogJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CompanyProfile/ReadChannelLogJSON";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  // Guest Visit Revenue Sync to BW & CRS Logs

  getGuestVisitRevenueSyncPropList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/GuestVisitBWandCRS/GetProperties";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  readGuestVisitRevenueSyncAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/GuestVisitBWandCRS/ReadLog";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  GuestVisitRevenueSyncJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/GuestVisitBWandCRS/ReadLogJson";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }


  // ITC CRM POS from CRB DB

  getITCCRMPOSPropList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/ITCCRM/GetITCPOSProperties";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  readITCCRMPOSAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/ITCCRM/ReadITCPOSLog";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  // ITCCRMPOSJSON(token:any, type:any) {
  //   let data = {'TOKEN':token,'TYPE':type};
  //   let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  //   let endPoint = this.newEndPoint + "/ITCCRM/ReadITCPOSLogJson";
  //   return this.http
  //     .post(endPoint,data, { headers: headers })
  //     .pipe(map(res => JSON.parse(JSON.stringify(res))));
  // }

  // ITC CRM FOM from CRB DB

  getITCCRMFOMPropList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/ITCCRM/GetITCFOMProperties";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  readITCCRMFOMAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/ITCCRM/ReadITCFOMLog";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
  //Indhuja 06-08-2025 start
readITCCRMFOMAPINew(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/ITCCRM/ReadITCFOMLogNew";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
    //ReadJSon Indhuja 01-09-2025
readITCCRMFOMAPINewJson(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/ITCCRM/ReadITCFOMLogJsonNew";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
  //Indhuja 06-08-2025 end
  ITCCRMFOMJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/ITCCRM/ReadITCFOMLogJson";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  // CPO Listed API Details:
  /* BillWise PMS Data*/
  getCPOBillWisePropList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CPOLog/GetProperties";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  readCPOBillWiseAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CPOLog/ReadBillwisePMSData";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  CPOBillWiseJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CPOLog/ReadBillwisePMSDataJSON";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* ACR CreditLimit*/
  readACRCreditLimitAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CPOLog/ReadACRCreditLimit";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  ACRCreditLimitJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CPOLog/ReadBillwisePMSDataJSON";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
  /* ACR CreditLimit*/
  readPayRollJVAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CPOLog/ReadPayRollJV";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* Others*/
  readOthersAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CPOLog/ReadCPOothersTbl";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  CPOOthersJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CPOLog/ReadCPOothersTblJSON";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* GSTR For ClearTax*/
  ReadGSTRForClearTaxAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CPOLog/ReadGSTRForClearTax";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }


  /* Inventory Transaction*/
  ReadInvTransAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CPOLog/ReadInventoryTransaction";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }


  /* Online Sales */
  ReadOnlineSalesAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CPOLog/ReadOnlineSales";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* Check In & Check Out */
  // To Bookingwhizz
  getToBookingwhizzPropList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CheckInCheckout/BWLogGetProperties";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  readToBookingwhizzAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CheckInCheckout/BWLogRead";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  ToBookingwhizzJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CheckInCheckout/BWLogGetJSON";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  // To FXCRS

  readToFXCRSAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CheckInCheckout/FXCRSLogRead";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  ToFXCRSJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CheckInCheckout/FXCRSLogGetJSON";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }


  /* General CRM - FX */
  getGeneralCRMFXPropList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CRM/GetGeneralFXProperties";
    return this.http
      .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  readGeneralCRMFXAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CRM/ReadGeneralFXProperties";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  GeneralCRMFXJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CRM/GeneralFXPropertiesJSON";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* TrustU Log */
  getTrustUPropList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/TruestU/GetProperties";
    return this.http
      .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  readTrustUAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/TruestU/Read";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  TrustUJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/CRM/GeneralFXPropertiesJSON";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* Red Alert Popup */
  getAlertPopupDataList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/RedAlert/Read";
    return this.http
     .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  readAlertPopup(USERID: any) {
    let data = { 'USERID': USERID }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/RedAlert/ReadSave";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  /* One Page Summary API */
  getOnePageGrpCodeList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/General/GetonpageGroupcode";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  GetOnePageProperties(requestPayload: any) {
    let data = { 'GROUPCODE': requestPayload }
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/General/GetonpageProperties";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  readOnePageSummary(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/General/OnePageSummary";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }


  /* WBHIDCO Screens */
  getWBHIDCOGetProperties() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/WBHIDCO/GetProperties";
    return this.http
     .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }


  getWBHIDCOlog(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/WBHIDCO/WBHIDCOReport";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }
  getReprocessWBHIDCOlog(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/WBHIDCO/WBHIDCOReprocess";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  getWBHIDCOJSON(TOKEN: any, TYPE: any) {
    let data = { 'TOKEN': TOKEN, 'TYPE': TYPE };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/WBHIDCO/GetWBHIDCOJSON";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }


  WBHIDCOJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/WBHIDCO/GetWBHIDCOJSON";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }


  // Sabre Inhouse Loyalty

  getSabreLoyaltyPropList() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/SabreInhouseLoyalty/GetProperties";
    return this.http
      .get(endPoint, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  readSabreLoyaltyAPI(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/SabreInhouseLoyalty/Read";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

  SabreLoyaltyJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/SabreInhouseLoyalty/ReadXML";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }



  /* DCTKPI UI Screens */
  getDCTKPIGetProperties() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/DCIKPTAbuDhabiLog/GetProperties";
    return this.http
      .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }


  getDCTKPIlog(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/DCIKPTAbuDhabiLog/Report";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }
  getReprocessDCTKPIlog(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/DCIKPTAbuDhabiLog/Reprocess";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  getDCTKPIJSON(TOKEN: any, TYPE: any) {
    let data = { 'TOKEN': TOKEN, 'TYPE': TYPE };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/DCTKPI/GetDCTKPIJSON";
   return this.http.post(endPoint,data,{headers:headers})
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }


  DCTKPIJSON(token: any, type: any) {
    let data = { 'TOKEN': token, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/DCTKPI/GetDCTKPIJSON";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }

/* Bitsila Log */
BitsilaLogAPI(FRMDATE: any, TOODATE: any,dH_Config_ID: any, store_id: any) {
  let data = { 'FRMDATE': FRMDATE, 'TOODATE': TOODATE, 'dH_Config_ID': dH_Config_ID, 'store_id': store_id };
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/BitsilaLog/ReadBitsilaLog";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}  

getBusinessList() {
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/BitsilaLog/ReadBusinessList";
  return this.http
   .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}


/* Tookan Log */
TookanLogAPI(FRMDATE: any, TOODATE: any,dH_Config_ID: any, store_id: any) {
  let data = { 'FRMDATE': FRMDATE, 'TOODATE': TOODATE, 'DH_Config_ID': dH_Config_ID, 'store_id': store_id };
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/TookanLog/ReadTookanLog";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}  

getTookanList() {
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/TookanLog/ReadBusinessList";
  return this.http
   .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}


/* BonusHub & RazorPay Log */
getPaymentOptionList() {
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/PaymentGateWayIntegeration/ReadPGIRectypeList";
  return this.http
   .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}

getPaymentPropRecordTypeList(SourceSystem:any) {
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/PaymentGateWayIntegeration/GetRectypeandPmscode/" + SourceSystem;
  return this.http
    .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}

getBonushubRazorpaylog(requestPayload: any) {
  let data = requestPayload
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/PaymentGateWayIntegeration/Read_PGI_Log";
  return this.http.post(endPoint, data, { headers: headers })
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}


/* Inv to FXCRS New Pipe Properties*/
getFXCRSNewPipeProperty() {
  // let data = { 'pmscode': pmsCustCode}
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/InventorytoFXCRSNewPipe/GetPropertyList";
  return this.http
    .get(endPoint, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}

getFXCRSNewPipelog(requestPayload: any) {
  let data = requestPayload
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/InventorytoFXCRSNewPipe/Read";
  return this.http.post(endPoint, data, { headers: headers })
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}

getFXCRSNewPipeXML(TOKEN: any, TYPE: any) {
  let data = { 'Token': TOKEN, 'Type': TYPE };
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/InventorytoFXCRSNewPipe/GetXML";
  return this.http.post(endPoint, data, { headers: headers })
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}

/* Rate to PMS New Pipe */
getRatePMSNewPipelog(requestPayload: any) {
  let data = requestPayload
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/RatetoPMSNewPipe/Read";
  return this.http.post(endPoint, data, { headers: headers })
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}

getRatePMSNewPipeXML(TOKEN: any, TYPE: any) {
  let data = { 'TOKEN': TOKEN, 'TYPE': TYPE };
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/RatetoPMSNewPipe/GetXML";
  return this.http.post(endPoint, data, { headers: headers })
   .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}

/* Change Password API */
changePassword(changePassword:any) {
  let data = changePassword
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = "https://fxionewadminportalapi.azurewebsites.net/api/BEOUsers/ChangePassword";
  return this.http
  .post(endPoint, data, { headers: headers })
  .pipe(map(res => JSON.parse(JSON.stringify(res))));
}

/* Forgot Password API */
forgotPasswordReqPayload(forgotPwdReqPayload:any) {
  let data = {"EmailID":forgotPwdReqPayload}
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = "https://fxionewadminportalapi.azurewebsites.net/api/User/ForgotPassword";
  return this.http
  .post(endPoint, data, { headers: headers })
  .pipe(map(res => JSON.parse(JSON.stringify(res))));
}

/* Mapping Details Log */
GetProvideList() {
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/FXEinvoice/GetProvideList";
  return this.http
    .get(endPoint, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}

ReadFXEinvoiceMappedDetails(requestPayload: any){
  let data = requestPayload
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/FXEinvoice/ReadFXEinvoiceMappedDetails";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}

/* FN to DH NewPipe Log */
GetFNtoDHNewPipePropList() {
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/FNtoDHNewPipe/GetPropetyList";
  return this.http
    .get(endPoint, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}

ReadFNtoDHNewPipe(requestPayload: any){
  let data = requestPayload
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/FNtoDHNewPipe/Read";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}
getFNtoDHNewPipeJSON(TOKEN: any, TYPE: any){
  let data = { 'Token': TOKEN, 'Type': TYPE };
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/FNtoDHNewPipe/GetJson";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}


/* SU integration */
GetPropSyncFXSU() {
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/SUIntegeration/GetPropertyList";
  return this.http
    .get(endPoint, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}

ReadPropSyncFXSU(requestPayload: any){
  let data = requestPayload
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/SUIntegeration/Read";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}
getPropSyncFXSUJSON(ID: any, TYPE: any){
  let data = { 'ID': ID, 'Type': TYPE };
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/SUIntegeration/GetJson";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}

/* RoomTypeSyncFXSU */
ReadRoomTypeSyncFXSU(requestPayload: any){
  let data = requestPayload
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/SUIntegeration/ReadSURoomtypeLog";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}
getRoomTypeSyncFXSUJSON(ID: any, TYPE: any){
  let data = { 'ID': ID, 'Type': TYPE };
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/SUIntegeration/GetJsonSURoomtypeLog";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}

/*  RatePlanSyncFXSU */

ReadRatePlanSyncFXSU(requestPayload: any){
  let data = requestPayload
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/SUIntegeration/ReadRatePlanSyncFromFXtoSU";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}
getRatePlanSyncFXSUJSON(ID: any, TYPE: any){
  let data = { 'ID': ID, 'Type': TYPE };
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/SUIntegeration/GetJsonRatePlanSyncFromFXtoSU";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}

/*  InventoryPlanSyncFXSU */
ReadInvSyncFXSU(requestPayload: any){
  let data = requestPayload
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/SUIntegeration/ReadInventorySyncfromFXtoSU";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}
getInvSyncFXSUJSON(ID: any, TYPE: any){
  let data = { 'ID': ID, 'Type': TYPE };
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/SUIntegeration/GetJsonInventorySyncfromFXtoSU";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}

/*  RateSyncFXSU */
ReadRateSyncFXSU(requestPayload: any){
  let data = requestPayload
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/SUIntegeration/ReadRateSyncfromFXtoSU";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}
getRateSyncFXSUJSON(ID: any, TYPE: any){
  let data = { 'ID': ID, 'Type': TYPE };
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/SUIntegeration/GetJsonRateSyncfromFXtoSU";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}

/*  RestrictionSyncfromFXtoSU */
ReadResSyncfromFXtoSU(requestPayload: any){
  let data = requestPayload
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/SUIntegeration/ReadRestrictionSyncfromFXtoSU";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}
getResSyncfromFXtoSUJSON(ID: any, TYPE: any){
  let data = { 'ID': ID, 'Type': TYPE };
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/SUIntegeration/GetJsonRestrictionSyncfromFXtoSU";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}



/*  Reservation Sync from SU to FX*/
ReadReservationSyncfromSUtoFX(requestPayload: any){
  let data = requestPayload
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/SUIntegeration/ReadReservationSyncfromSUtoFX";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}
getReservationSyncfromSUtoFXJSON(TOKEN: any, TYPE: any){
  let data = { 'TOKEN': TOKEN, 'Type': TYPE };
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/SUIntegeration/GetJsonReservationSyncfromSUtoFX";
  return this.http
    .post(endPoint, data, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}

//OHIP - Log - Indhuja 22-10-2024
GetOHIPLogPropertyList()
{
  let headers=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/OHIPLog/GetPropertyList";
  return this.http
  .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
ReadOHIPLog(requestPayload: any)
{
  let data=requestPayload;
  let headers=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/OHIPLog/ReadOHIPLog";
  return this.http
  .post(endPoint,data,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
GetOHIPJson(ID:any,type:any)
{
  let data={ 'ID': ID, 'Type': type };
  let headers=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/OHIPLog/GetOHIPLogJson";
  return this.http
  .post(endPoint,data,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
//Indhuja 22-10-2024
//Indhuja 22-10-2024
//New FN Config Info - Indhuja 19-11-2024
GetPropertiesNewFNConfigInfo()
{
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/General/GetPropertiesNewFNConfigInfo"
  return this.http
  .get(endPoint,{headers:header})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
readNewFNConfigInfo(requestPayload: any) {
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/General/ReadNewFNConfigInfo";
  return this.http.post(endPoint,requestPayload, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}

//New FN DH Sync Report - Indhuja 05-12-2024
readnewfndhsyncreport(requestPayload: any) {
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let endPoint = this.newEndPoint + "/General/ReadNewFNDHSyncReport/"+requestPayload;
  return this.http.get(endPoint, { headers: headers })
    .pipe(map(res => JSON.parse(JSON.stringify(res))));
}
//GetProperty for Bookingsform ch to fn new pipe Indhuja 10-12-2024
getbookingfromchtofnnewpipeproperty()
{
  let headers=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/Bookinglog/GetPropertyBookingsCHtoFXNewPipe";
  return this.http.get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
//Read for Bookingsform ch to fn new pipe Indhuja 10-12-2024
readbookingfromchtofnnewpipe(PMSCUSTCODE: any, CMCODE: any, selectedDate: any, selectedTOODate: any, PGF: any, PGT: any, searchParam: any)
{
  let data={ 'PMSCODE': PMSCUSTCODE, 'CMCODE': CMCODE, 'FRMDATE': selectedDate, 'TOODATE': selectedTOODate, 'PaginationFromId': PGF, 'PaginationToId': PGT, "Search": searchParam }
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/Bookinglog/ReadBookingsCHtoFXNewPipe";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
//Read XML for Bookingsform ch to fn new pipe Indhuja 10-12-2024
readxmlbookingfromchtofnnewpipe(TOKEN: any, Type: any)
{
  let data={  'ID': TOKEN ,'TYPE': Type};
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/Bookinglog/GetXMLBookingsCHtoFNNewPipe";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
//Get Property List for Data Lake Log 12-12-2024
getdatalakepropertylist()
{
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/DataLake/GetProperty";
  return this.http.get(endPoint,{headers:header})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
//Read Data for Data Lake Log 12-12-2024
readdatalakelog(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any)
{
  let data={'PMSCODE':PMSCUSTCODE,'FRMDATE':selectedDate,'TOODATE':selectedTOODate};
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/DataLake/Read";
  return this.http.post(endPoint,data,{headers:header})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
//FXCRS to Channels Inventory Flow Report Indhuja 17-12-2024
fxcrstochinvgetproperties()
{
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/Inventorylog/FXCRStoCHGetProperty";
  return this.http.get(endPoint,{headers:header})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
fxcrstochinvreportread(PMSCUSTCODE: any,RUNDATE:any,ROMTYP:any, CMCODE: any, selectedDate: any, selectedTOODate: any, PGF: any, PGT: any, searchParam: any,SOURCE:any)
{
  let data={'PMSCODE':PMSCUSTCODE,'DATE':selectedDate,'CMCODE':CMCODE,'ROOMTYP':ROMTYP,'PaginationFromId': PGF, 'PaginationToId': PGT,'SOURCE':SOURCE};
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/Inventorylog/FXCRStoCHRead";
  return this.http.post(endPoint,data,{headers:header})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
fxcrstochinvreportgetxml(TOKEN: any, Type: any)
{
  let data={  'TOKEN': TOKEN ,'TYPE': Type};
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/Inventorylog/FXCRStoCHReadXML";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
// Get Property List for TIC Log - Timali 23-12-2024
gettajInnerCirclepropertylist()
{
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/TICLog/GetProperties";
  return this.http.get(endPoint,{headers:header})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}

//Read Data for TIC Log  - Timali 23-12-2024
readtajInnerCirclelist(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any,status: any)
{
  let data={'PMSCODE':PMSCUSTCODE,'FRMDATE':selectedDate,'TOODATE':selectedTOODate,'STATUS':status};
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/TICLog/Read";
  return this.http.post(endPoint,data,{headers:header})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
//Indhuja 17-06-2025 - TIC Reprocess
reprocesstajInnerCircle(PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any)
{
   let data={'PMSCODE':PMSCUSTCODE,'FRMDATE':selectedDate,'TOODATE':selectedTOODate};
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/TICLog/TICReprocess";
  return this.http.post(endPoint,data,{headers:header})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}

//FN to Channels Inventory Flow Report Indhuja 23-12-2024
fntochinvgetproperties()
{
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/Inventorylog/FNtoCHGetProperty";
  return this.http.get(endPoint,{headers:header})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
fntochinvreportread(PMSCUSTCODE: any,RUNDATE:any,ROMTYP:any, CMCODE: any, selectedDate: any, selectedTOODate: any, PGF: any, PGT: any, searchParam: any,SOURCE:any)
{
  let data={'PMSCODE':PMSCUSTCODE,'DATE':selectedDate,'CMCODE':CMCODE,'ROOMTYP':ROMTYP,'PaginationFromId': PGF, 'PaginationToId': PGT,'SOURCE':SOURCE};
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/Inventorylog/FNtoCHRead";
  return this.http.post(endPoint,data,{headers:header})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
fntochinvreportgetxml(TOKEN: any, Type: any)
{
  let data={  'TOKEN': TOKEN ,'TYPE': Type};
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/Inventorylog/FNtoCHReadJson";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
//Get Roomtype FXCRS  and FN to Channels Inventory Flow Report Indhuja 24-12-2024(both screens)
fxcrstochinvreportgetroomtype(PMSCODE: any)
{
  let data={  'PMSCODE': PMSCODE };
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/Inventorylog/FXCRStoCHReadRoomType";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}

//Get Properties New FN Pipe Actions - Indhuja 24-01-2025
newfnpipeactionsgetproperties()
{
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/NewFNPipeActions/GetProperties";
  return this.http.get(endPoint,{headers:header})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
//Read New FN Pipe Actions - Indhuja 24-01-2025
/* newfnpipeactionsread(PMSCODE: any, Type: any)
{
  let data={  'pmscode': PMSCODE ,'type': Type};
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/NewFNPipeActions/ReadSave";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
} */
    newfnpipeactionsread(PMSCODE: any, Type: any,Userid:any) {
      let data = { 'pmscode': PMSCODE, 'type': Type,'userid':Userid };
      let header = new HttpHeaders({'Content-Type': 'application/json'});
      let endPoint = this.newEndPoint + "/NewFNPipeActions/ReadSave";
      return this.http.post(endPoint, data, { headers: header })
        .pipe(map(res => JSON.parse(JSON.stringify(res))));
    }
    newfnpipeactionloadreadsave(PMSCODE:any,ACTION: any, STATUS: any, CRBY: any, FLAG: any)
    {
      let data = { 'PMSCODE': PMSCODE, 'ACTION': ACTION,'STATUS':STATUS,'CRBY':CRBY,'FLAG':FLAG};
      let header = new HttpHeaders({'Content-Type': 'application/json'});
      let endPoint = this.newEndPoint + "/NewFNPipeActions/ReadSaveLog";
      return this.http.post(endPoint, data, { headers: header })
        .pipe(map(res => JSON.parse(JSON.stringify(res))));
    }
    //Indhuja 10-03-2025 Start
    getnewqatarproperties()
    {
      let header=new HttpHeaders({'Content-Type':'application/json'});
      let endPoint=this.newEndPoint+"/Qatar/GetPropertiesQatarLogData";
      return this.http.get(endPoint,{headers:header})
      .pipe(map(res=>JSON.parse(JSON.stringify(res))))
    }
    readnewQatarLogsData(requestPayload: any)
    {
      let data=requestPayload;
      let header=new HttpHeaders({'Content-Type':'application/json'});
      let endPoint=this.newEndPoint+"/Qatar/ReadQatarLogData";
      return this.http.post(endPoint,data,{headers:header})
      .pipe(map(res=>JSON.parse(JSON.stringify(res))))
    }
    readnewQatarLogsXML(TOKEN: any, Type: any)
    {
      let data={'TOKEN': TOKEN ,'TYPE': Type}
      let header=new HttpHeaders({'Content-Type':'application/json'});
      let endPoint=this.newEndPoint+"/Qatar/GetXMLQatarLogData";
      return this.http.post(endPoint,data,{headers:header})
      .pipe(map(res=>JSON.parse(JSON.stringify(res))))
    }
     //Indhuja 10-03-2025 End
     //Indhuja 05-03-2025 Start
    readdhsummarydetails()
    {
      let header=new HttpHeaders({'Content-Type':'application/json'});
      let endPoint=this.newEndPoint+"/General/DHProductSummaryDetails";
      return this.http.get(endPoint,{headers:header})
      .pipe(map(res=>JSON.parse(JSON.stringify(res))));
    }
    //Indhuja 05-03-2025 End
 /*     //Indhuja 08-09-2025 Start
    readPhaseIIEngineRequestlog( PMSCUSTCODE: any,CMCODE: any, selectedDate: any, selectedTOODate: any, PGF: any, PGT: any, searchParam: any)
{
  //'PMSCODE': ,//
  let data={'pmscode':PMSCUSTCODE,  'channelCode': CMCODE, 'frmdate': selectedDate, 'toodate': selectedTOODate, 'paginationFrom': PGF, 'paginationTo': PGT, "Search": searchParam }
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/PhaseII/ReadRequestTBL";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
    //Indhuja 08-09-2025 End */
    //Indhuja 08-09-2025 Start
    readPhaseIIEnginegetchannellog(requestLogID: any,cmcode:any)
{
  let data={ 'requestLogID': requestLogID,'channelCode':cmcode }
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/PhaseII/GetChannelTableData";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
    //Indhuja 08-09-2025 End
     //Indhuja 08-09-2025 Start
    getpropertydetailsPhaseIIEngine()
    {
      let header=new HttpHeaders({'Content-Type':'application/json'});
      let endPoint=this.newEndPoint+"/PhaseII/GetPmscodeandCmcode";//GetPmscodeandCmcodess
      return this.http.get(endPoint,{headers:header})
      .pipe(map(res=>JSON.parse(JSON.stringify(res))));
    }
    //Indhuja 08-09-2025 End
     //Indhuja 08-09-2025 Start
    phaseIIResyncAPI(requestPayload: string,RequestLogID:string,channelName:string,RowKey:string,UserID:string) {
      let data={'RequestUrl':requestPayload,'RequestLogID':RequestLogID,'channelName':channelName,'RowKey':RowKey,'UserID':UserID}
  
      let header = new HttpHeaders({ 'Content-Type': 'application/json' });
      let endPoint = this.newEndPoint + "/PhaseIIReportsOldTBL/PhaseIIOldTBLResync"; //SavePhaseIIResync";
      return this.http.post(endPoint, data, { headers: header, responseType: 'text' })
      .pipe( map(res => {
        try {
          return JSON.parse(res);  
        } catch {
          return res;             
        }
      })
    );
}
//Indhuja 08-09-2025 Start
    phaseIINewTBLResyncAPI(requestPayload: string,RequestLogID:string,channelName:string,RowKey:string,UserID:string,ChannelURL:string) {
      let data={'RequestUrl':requestPayload,'RequestLogID':RequestLogID,'channelName':channelName,'RowKey':RowKey,'UserID':UserID,'ChannelURL':ChannelURL}
  
      let header = new HttpHeaders({ 'Content-Type': 'application/json' });
      let endPoint = this.newEndPoint + "/PhaseReportsNewTBL/PhaseIINewTBLResync"; //SavePhaseIIResync";
      return this.http.post(endPoint, data, { headers: header, responseType: 'text' })
      .pipe( map(res => {
        try {
          return JSON.parse(res);  
        } catch {
          return res;             
        }
      })
    );
}
exportExcel(payload: any) {
  return this.http.post(
    this.newEndPoint + '/PhaseII3ReadReqLog/ExportPhaseIIExcel',
    payload,
    { responseType: 'blob' }
  );
}
exportExcel2026(payload: any) {
  return this.http.post(
    this.newEndPoint + '/PhaseII3ReadReqLog/ExportPhaseIIExcel2026',
    payload,
    { responseType: 'blob' }
  );
}
readphaseIIwithresyncdatetime( PMSCUSTCODE: any,CMCODE: any, selectedDate: any, selectedTOODate: any, PGF: any, PGT: any, searchParam: any)
{
  //'PMSCODE': ,//
  let data={'pmscode':PMSCUSTCODE,  'channelCode': CMCODE, 'frmdate': selectedDate, 'toodate': selectedTOODate, 'paginationFrom': PGF, 'paginationTo': PGT, "Search": searchParam }
  let header=new HttpHeaders({'Content-Type':'application/json'});
  //let endPoint=this.newEndPoint+"/PhaseII/ReadRequestTBL";
  let endPoint=this.newEndPoint+"/ReadPhaseIILog/GetPhaseIIData";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
//Indhuja 13-10-2025 Start
        //Indhuja 17-11-2025
    readphaseIIwithresyncdatetimeNew( PMSCUSTCODE: any,CMCODE: any, selectedDate: any, selectedTOODate: any, PGF: any, PGT: any, searchParam: any,transactionType:any)
{
  //'PMSCODE': ,//
  let data={'pmscode':PMSCUSTCODE,  'channelCode': CMCODE, 'frmdate': selectedDate, 'toodate': selectedTOODate, 'paginationFrom': PGF, 'paginationTo': PGT, "Search": searchParam,"TransactionType":transactionType }
  let header=new HttpHeaders({'Content-Type':'application/json'});
  //let endPoint=this.newEndPoint+"/PhaseII/ReadRequestTBL";
  let endPoint=this.newEndPoint+"/PhaseIIReportsOldTBL/GetPhaseIIReports";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
    //Indhuja 17-11-2025
//Indhuja 21-06-2026 Start 
    readphaseIIReportsYearTBLNew( PMSCUSTCODE: any,CMCODE: any, selectedDate: any, selectedTOODate: any, PGF: any, PGT: any, searchParam: any,transactionType:any)
{
  //'PMSCODE': ,//
  let data={'pmscode':PMSCUSTCODE,  'channelCode': CMCODE, 'frmdate': selectedDate, 'toodate': selectedTOODate, 'paginationFrom': PGF, 'paginationTo': PGT, "Search": searchParam,"TransactionType":transactionType }
  let header=new HttpHeaders({'Content-Type':'application/json'});
  //let endPoint=this.newEndPoint+"/PhaseII/ReadRequestTBL";
  let endPoint=this.newEndPoint+"/PhaseReportsNewTBL/GetPhaseIIReports2026";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
    //Indhuja 21-06-2026 END
    //Indhuja 28-07-2026 Start 
    readphaseIIUploadReportsYearTBLNew( PMSCUSTCODE: any,CMCODE: any, selectedDate: any, selectedTOODate: any, PGF: any, PGT: any, searchParam: any,transactionType:any)
{
  //'PMSCODE': ,//
  let data={'pmscode':PMSCUSTCODE,  'channelCode': CMCODE, 'frmdate': selectedDate, 'toodate': selectedTOODate, 'paginationFrom': PGF, 'paginationTo': PGT, "Search": searchParam,"TransactionType":transactionType }
  let header=new HttpHeaders({'Content-Type':'application/json'});
  //let endPoint=this.newEndPoint+"/PhaseII/ReadRequestTBL";
  let endPoint=this.newEndPoint+"/ReadPhaseIIUploadReport/GetUploadReservationLogsChannelWise";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
    //Indhuja 28-07-2026 END
    //Indhuja 21-06-2026 Start
    readphaseIIExcelReportsYearTBLNew( PMSCUSTCODE: any,CMCODE: any, selectedDate: any, selectedTOODate: any, searchParam: any,transactionType:any)
{
  //'PMSCODE': ,//
  let data={'pmscode':PMSCUSTCODE,  'channelCode': CMCODE, 'frmdate': selectedDate, 'toodate': selectedTOODate,  "Search": searchParam,"TransactionType":transactionType }
  let header=new HttpHeaders({'Content-Type':'application/json'});
  //let endPoint=this.newEndPoint+"/PhaseII/ReadRequestTBL";
  let endPoint=this.newEndPoint+"/PhaseReportsNewTBL/ExportPhaseIIReports2026";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
    //Indhuja 21-06-2026 END
getbingoforceproperties()
    {
      let header=new HttpHeaders({'Content-Type':'application/json'});
      let endPoint=this.newEndPoint+"/BingoForce/GetProperties";
      return this.http.get(endPoint,{headers:header})
      .pipe(map(res=>JSON.parse(JSON.stringify(res))));
    }
    
    readbingoforcelog( PMSCUSTCODE: any, selectedDate: any, selectedTOODate: any,   status: any,searchParam: any,PGF: any, PGT: any)
{//PGF: any, PGT: any,
  //'PMSCODE': ,//
  let data={'PMSCODE':PMSCUSTCODE,  'FRMDATE': selectedDate, 'TOODATE': selectedTOODate,  "Status": status, "Search": searchParam ,'PaginationFromId': PGF, 'PaginationToId': PGT}
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/BingoForce/Read";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
  readBingoforcejson(id: any, type: any) {
    let data = { 'ID': id, 'TYPE': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/BingoForce/GetBingoForcejson";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
    //Indhuja 13-10-2025 End
    //Indhuja 13-10-2025 Start
getfxproperties()
    {
      let header=new HttpHeaders({'Content-Type':'application/json'});
      let endPoint=this.newEndPoint+"/FXReqProcessLog/GetProperties";
      return this.http.get(endPoint,{headers:header})
      .pipe(map(res=>JSON.parse(JSON.stringify(res))));
    }
    
    readfxpropertieslog( PMSCUSTCODE: any,productCode:any, selectedDate: any, selectedTOODate: any,   status: any,searchParam: any,PGF: any, PGT: any)
{//PGF: any, PGT: any,
  //'PMSCODE': ,//
  let data={'PMSCODE':PMSCUSTCODE,'ProductCode':productCode,  'FRMDATE': selectedDate, 'TOODATE': selectedTOODate,  "Status": status, "Search": searchParam ,'PaginationFromId': PGF, 'PaginationToId': PGT}
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/FXReqProcessLog/Read";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
readfxPropertiesJson(ID:any,ProductCode:any,RequestType:any,)
{
  let data={'ID':ID,  'ProductCode': ProductCode,'RequestType':RequestType}
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/FXReqProcessLog/ReadJson";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
//Indhuja 30-10-2025 Start
getPropertiesWSLog()
{
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/AzureWSLOG/GetProperties";
  return this.http.get(endPoint,{headers:header})
      .pipe(map(res=>JSON.parse(JSON.stringify(res))));

}
readWSLog(PMSCODE:any,CDATE:any)
{
  let data={'PMSCODE':PMSCODE,  'CDATE': CDATE}
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/AzureWSLOG/ReadWSLOG";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
//Indhuja 30-10-2025 End
    //Indhuja 04-12-2025 Start
    savePhaseIIBulkResync(requestList: any[]) {
    const url = this.newEndPoint + "/PhaseIIBulkResync/SavePhaseIIBulkResyncs";
    const headers = new HttpHeaders({'Content-Type': 'application/json' });
    return this.http.post(url, requestList, { headers: headers });
}

    //Indhuja 04-12-2025 End

     /* NepalFNMIS Screens Indhuja 13.03.2026 */
  getNepalFNMISGetProperties() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/NepalFNMIS/GetPropertyList";
    return this.http
      .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
  }

  readNepalFNMISData(requestPayload: any) {
    let data = requestPayload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/NepalFNMIS/Read";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
    readNepalFNMISJson(PMSCUSTCODE: any, token: any, type: any) {
    let data = { 'pmscode': PMSCUSTCODE, 'token': token, 'type': type };
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let endPoint = this.newEndPoint + "/NepalFNMIS/ReadJson";
    return this.http
      .post(endPoint, data, { headers: headers })
      .pipe(map(res => JSON.parse(JSON.stringify(res))));
  }
  //WhatsappLog Indhuja 06.05.2026 Start
  GetWhatsappLogPropertyList()
{
  let headers=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/Whatsapp/GetWhatsappLogProperties";
  return this.http
  .get(endPoint,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
ReadWhatsappLog(requestPayload: any)
{
  let data=requestPayload;
  let headers=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/Whatsapp/ReadWhatsappLog";
  return this.http
  .post(endPoint,data,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
GetWhatsappLogJson(ID:any,type:any)
{
  let data={ 'ID': ID, 'Type': type };
  let headers=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/Whatsapp/ReadWhatsappLogJson";
  return this.http
  .post(endPoint,data,{headers:headers})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
  //Indhuja 06.05.2026 End
  //Indhuja 15-07-2026 Start 
    ReadChannelSummaryTblPhaseII( PMSCUSTCODE: any,CMCODE: any, selectedDate: any, selectedTOODate: any, PGF: any, PGT: any, searchParam: any,transactionType:any)
{
  //'PMSCODE': ,//
  let data={'PMSCode':PMSCUSTCODE,  'channelCode': CMCODE, 'FromDate': selectedDate, 'ToDate': selectedTOODate, 'paginationFrom': PGF, 'paginationTo': PGT, "Search": searchParam,"TransactionType":transactionType }
  let header=new HttpHeaders({'Content-Type':'application/json'});
  //let endPoint=this.newEndPoint+"/PhaseII/ReadRequestTBL";
  let endPoint=this.newEndPoint+"/ReadChannelSummaryTblPhaseII/GetReservationLogs";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
    //Indhuja 15-07-2026 END

//Phase II FN to Channels Inventory Flow Report Indhuja 20.08.2026
PhaseIIfntochinvgetproperties()
{
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/InventoryLogPhaseII/GetProperties";
  return this.http.get(endPoint,{headers:header})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
PhaseIIfntochinvreportread(PMSCUSTCODE: any,RUNDATE:any,ROMTYP:any, CMCODE: any, selectedDate: any, selectedTOODate: any, PGF: any, PGT: any, searchParam: any,SOURCE:any)
{
  let data={'PMSCODE':PMSCUSTCODE,'DATE':selectedDate,'CMCODE':CMCODE,'ROOMTYP':ROMTYP,'PaginationFromId': PGF, 'PaginationToId': PGT,'SOURCE':SOURCE};
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/InventoryLogPhaseII/ReadLog";
  return this.http.post(endPoint,data,{headers:header})
  .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}

//Get Roomtype FXCRS  and FN to Channels Inventory Flow Report Indhuja 20.08.2026
PhaseIIfxcrstochinvreportgetroomtype(PMSCODE: any,CMCODE:any)
{
  let data={  'PMSCODE': PMSCODE ,'CMCODE':CMCODE};
  let header=new HttpHeaders({'Content-Type':'application/json'});
  let endPoint=this.newEndPoint+"/InventoryLogPhaseII/GetRoomtype";
  return this.http.post(endPoint,data,{headers:header})
    .pipe(map(res=>JSON.parse(JSON.stringify(res))))
}
}
